export default {
  scheduled_order: 'Ajastettu tilaus',
  show_more: 'Näytä lisää',
  show_less: 'Näytä vähemmän',
  schedule_order: 'Ajasta tilaus',
};
